var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert alert-info mb-8 md:items-center"},[_c('app-icon',{staticClass:"w-12 h-12 md:w-6 md:h-6 mr-4",attrs:{"name":"info-circle","stroke":""}}),_vm._v("\n    Changes to these settings will be finalized once you have saved the page.\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }